// Libs
import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

// Components
import Message from "./Message/Message.jsx";
import Header from "../Header/Header.jsx"

// Services
import { GET } from "../../services/Bridge.js";

// Style
import style from './style.module.css';

const MessageBox = ({ toggleWebLanguage, webLanguage, toggleTheme, webTheme, webText, userData, logMeOut }) => {

  const { enqueueSnackbar } = useSnackbar();

  const [messages, setMessages] = useState([]);

  useEffect(() => {

    const asyncFunction = async () => {
      try {
          const response = await GET("demands");

          // Short messages to default
          response.messages.sort((a, b) => b.dateAdded - a.dateAdded);

          setMessages(response.messages);

      } catch (error) {
          enqueueSnackbar(error, {
            variant: "error",
            autoHideDuration: 5000,
          });
      };
    };

    asyncFunction();

  // eslint-disable-next-line
  }, []);

  return (
    <>
      <Header
        webText={webText}
        toggleTheme={toggleTheme}
        toggleWebLanguage={toggleWebLanguage}
        webLanguage={webLanguage}
        webTheme={webTheme}
        logMeOut={logMeOut}
      />
      <div className={style.page}>
        <main className={style.main}>

          <header className={style.header}>
            <p className={style.date}>Dátum odoslania</p>
            <p className={style.sender}>Odosielateľ</p>
            <p className={style.contact}>Kontakt</p>
          </header>

          <section className={style.messageList}>
            {!messages.length ? <p>Nemáte žiadnu správu</p> :
              <>
                {messages.map((message, index) => (
                  <Message
                    key={index}
                    message={message}
                    webText={webText}
                    newMessages={data => setMessages(data)}
                  />
                ))}
              </>
            }
          </section>

        </main>
      </div>
    </>
  );
};

export default MessageBox;